import Vue from 'vue';
import VueRouter from 'vue-router';
import skillTrain from './module/skill-train';
import notice from './module/notice';
import collegeTrends from './module/college-trends';
import policyFiles from './module/policy-files';
import downloadZone from './module/download-zone';
import education from './module/education';
import partyConstruction from './module/party-construction';

Vue.use(VueRouter);

const routes = [{
    path: '/',
    redirect: '/index',
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('@/views/index/index.vue'),
    meta: {
      title: '鲁迅文化基金会',
    },
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '基金会介绍',
      tabKey: 'foundation',
      hiddenCarousel: true,
    },
  },
  {
    path: '/about/list',
    name: 'about-list',
    component: () => import('@/views/about/list.vue'),
    meta: {
      title: '图片展示',
      hiddenCarousel: true,
    },
  },
  {
    path: '/about/foundation',
    name: 'about-foundation',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '基金会介绍',
      tabKey: 'foundation',
      hiddenCarousel: true,
    },
  },
  {
    path: '/about/council-supervisors',
    name: 'about-council-supervisors',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '理事会及监事会',
      tabKey: 'council-supervisors',
      hiddenCarousel: true,
    },
  },
  {
    path: '/about/charter',
    name: 'about-charter',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '基金会章程',
      tabKey: 'charter',
      hiddenCarousel: true,
    },
  },
  {
    path: '/about/governance',
    name: 'about-governance',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '管理制度',
      tabKey: 'governance',
      hiddenCarousel: true,
    },
  },
  {
    path: '/about/certificates',
    name: 'about-certificates',
    component: () => import('@/views/about/index.vue'),
    meta: {
      title: '资质证书',
      tabKey: 'certificates',
      hiddenCarousel: true,
    },
  },
  {
    path: '/message',
    name: 'message',
    component: () => import('@/views/message/index.vue'),
    meta: {
      title: '信息公开',
      hiddenCarousel: true,
    },
  },
  {
    path: '/message/gzbg',
    name: 'message-gzbg',
    component: () => import('@/views/message/gzbg.vue'),
    meta: {
      title: '工作报告',
      hiddenCarousel: true,
    },
  },
  {
    path: '/message/glzd',
    name: 'message-glzd',
    component: () => import('@/views/message/glzd.vue'),
    meta: {
      title: '管理制度',
      hiddenCarousel: true,
    },
  },
  {
    path: '/message/list',
    name: 'message-list',
    component: () => import('@/views/message/list.vue'),
    meta: {
      title: '爱心榜',
      hiddenCarousel: true,
    },
  },
  {
    path: '/message/detail',
    name: 'message-detail',
    component: () => import('@/views/message/detail.vue'),
    meta: {
      title: '报告详情',
      hiddenCarousel: true,
    },
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('@/views/support/index.vue'),
    meta: {
      title: '捐赠信息',
      tabKey: 'donation',
      hiddenCarousel: true,
    },
  },
  {
    path: '/support/donation',
    name: 'support-donation',
    component: () => import('@/views/support/index.vue'),
    meta: {
      title: '捐赠信息',
      tabKey: 'donation',
      hiddenCarousel: true,
    },
  },
  {
    path: '/support/volunteers',
    name: 'support-volunteers',
    component: () => import('@/views/support/index.vue'),
    meta: {
      title: '志愿者招募',
      tabKey: 'volunteers',
      hiddenCarousel: true,
    },
  },
  {
    path: '/support/contact',
    name: 'support-contact',
    component: () => import('@/views/support/index.vue'),
    meta: {
      title: '联系我们',
      tabKey: 'contact',
      hiddenCarousel: true,
    },
  },
  {
    path: '/support/detail',
    name: 'support-detail',
    component: () => import('@/views/support/detail.vue'),
    meta: {
      title: '支持我们-详情',
      hiddenCarousel: true,
    },
  },
  {
    path: '/support/jksm',
    name: 'support/jksm',
    component: () => import('@/views/support/jksm.vue'),
    meta: {
      title: '捐款说明',
      hiddenCarousel: true,
    },
  },
  {
    path: '/support/zyzzm',
    name: 'support/zyzzm',
    component: () => import('@/views/support/zyzzm.vue'),
    meta: {
      title: '志愿者招募',
      hiddenCarousel: true,
    },
  },
  ...skillTrain,
  ...notice,
  ...collegeTrends,
  ...policyFiles,
  ...downloadZone,
  ...education,
  ...partyConstruction,
  {
    path: '/classOpen',
    name: 'classOpen',
    component: () => import('@/views/class-open/index.vue'),
    meta: {
      title: '培训资讯',
    },
  },
  {
    path: '/classOpen/detail',
    name: 'classOpen-detail',
    component: () => import('@/views/class-open/detail.vue'),
    meta: {
      title: '培训资讯',
      hiddenCarousel: true,
    },
  },
  {
    path: '/imageNews/detail',
    name: 'image-news-detail',
    component: () => import('@/views/index/image-news.vue'),
    meta: {
      title: '图片新闻',
      hiddenCarousel: true,
    },
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/index/search.vue'),
    meta: {
      hiddenCarousel: true,
    },
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else if (to.path.includes('/skillTrain') && from.path.includes('/skillTrain')) {
      return {};
    } else if (from.path.includes(to.path)) {
      return {};
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.query.documentTitle) {
    document.title = to.query.documentTitle;
  } else if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = process.env.VUE_APP_SYSTEM_NAME;
  }
  next();
});

router.afterEach(() => {
  // console.log(to, from)
});

export default router;
